import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import EventEditionFormWrapper from 'src/Components/Forms/Event/EventEditionFormWrapper/EventEditionFormWrapper.component';

type EventParams = {
  eventId: string;
};

const EditEventDrawer = () => {
  const { t } = useTranslation();
  const { eventId } = useParams<EventParams>();

  if (!eventId) {
    return <Navigate to="/planning" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('editEventForm.editEvent', "Modifier l'événement")}>
      {({ onClose }) => (
        <EventEditionFormWrapper onCreate={onClose} onCancel={onClose} eventId={eventId} />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default EditEventDrawer;
